import React, { useState, useRef, useEffect } from "react";
import { sendMessage, setTypingStatus } from "../services/chatService";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

const MessageInput = ({ me, partner, chatEndRef }) => {
  const [text, setText] = useState("");
  const [uploading, setUploading] = useState(false);
  const textareaRef = useRef(null);

  const send = async () => {
    const trimmed = text.trim();
    if (!trimmed) return;
    setText("");
    try {
      await sendMessage(me.id, partner.id, trimmed, "text");
      setText(""); // Clear textarea
      scrollToBottom();
    } finally {
      setTypingStatus(me.id, partner.id, false);
    }
  };

  const sendImage = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      setUploading(true);

      const storage = getStorage();
      const fileRef = ref(storage, `chat_images/${Date.now()}_${file.name}`);

      await uploadBytes(fileRef, file);
      const url = await getDownloadURL(fileRef);

      await sendMessage(me.id, partner.id, url, "image");
      scrollToBottom();
    } catch (err) {
      console.error("Image upload error:", err);
    } finally {
      setUploading(false);
      setText(""); // clear textarea after image send
      setTypingStatus(me.id, partner.id, false);
    }
  };

  const scrollToBottom = () => {
    // scroll chat to bottom
    if (chatEndRef?.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div style={styles.container}>
      <textarea

        ref={textareaRef}
        value={text}
        onChange={(e) => {
              setText(e.target.value);
              setTypingStatus(me.id, partner.id, true);
            }}
            onBlur={() => setTypingStatus(me.id, partner.id, false)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                send();             
              }
            }}

        style={styles.textarea}
        placeholder="Type message..."
        rows={2} // can expand dynamically if you want
      />

      {/* Image Upload */}
      {/* <label style={styles.uploadBtn}>
        📷
        <input type="file" accept="image/*" onChange={sendImage} hidden />
      </label> */}

      <button style={styles.sendBtn} onClick={send} disabled={uploading}>
        {uploading ? "..." : "Send"}

        
      </button>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    padding: "10px",
    borderTop: "1px solid #ddd",
    background: "#f9f9f9", // lighter background
    alignItems: "flex-end",
    gap: "8px", // space between textarea and button
  },

  
  textarea: {
    flex: 1,
    padding: "10px 12px",
    fontSize: "15px",
    borderRadius: "20px", // rounder edges like modern chat
    border: "1px solid #ccc",
    outline: "none",
    resize: "none",
    background: "#fff",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    transition: "all 0.2s",
    lineHeight: "1.4",
  },
  textareaFocus: {
    borderColor: "#007bff", // blue border on focus
    boxShadow: "0 0 5px rgba(0,123,255,0.3)",
  },
  uploadBtn: {
    marginLeft: 8,
    marginRight: 8,
    cursor: "pointer",
    fontSize: 22,
  },
  sendBtn: {
    padding: "10px 18px",
    backgroundColor: "rgb(191, 50, 114)",
    color: "#fff",
    border: "none",
    borderRadius: "20px", // match textarea roundness
    cursor: "pointer",
    fontWeight: "bold",
    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
    transition: "all 0.2s",
  },
  sendBtnHover: {
    background: "#0056b3",
    boxShadow: "0 3px 7px rgba(0,0,0,0.25)",
  },
};


export default MessageInput;
